import { ApplyOnlineOptionsConst } from "@/src/constants/apply-online";

export interface DegreeSelectOption {
  value: string;
  label: string;
  disabled?: boolean;
  hidden?: boolean;
}

export const STANDARD_DEGREE_LEVEL_VALUES = ApplyOnlineOptionsConst.levelEducation
  .filter((item) => Boolean(item.value) && !item.disabled)
  .map((item) => item.value);

export const DEFAULT_DEGREE_LEVEL = "Bachelor's Degree";

export const resolveDegreeValue = (value?: string | null): string => {
  const trimmed = (value ?? "").trim();
  return trimmed || DEFAULT_DEGREE_LEVEL;
};

export const isStandardDegreeLevel = (value?: string | null): boolean => {
  const trimmed = (value ?? "").trim();
  return trimmed !== "" && STANDARD_DEGREE_LEVEL_VALUES.includes(trimmed);
};

/** Placeholder + 3 standard degrees; legacy/custom value is kept as a hidden selected option. */
export const buildDegreeSelectOptions = (
  currentValue?: string | null,
  placeholderLabel = "Degree Level",
): DegreeSelectOption[] => {
  const options: DegreeSelectOption[] = ApplyOnlineOptionsConst.levelEducation.map((item) => ({
    value: item.value,
    label: item.value === "" && item.disabled ? placeholderLabel : item.label,
    disabled: item.disabled,
  }));

  const trimmed = (currentValue ?? "").trim();
  if (trimmed && !isStandardDegreeLevel(trimmed)) {
    options.splice(1, 0, { value: trimmed, label: trimmed, hidden: true });
  }

  return options;
};
